// apps/web/src/content/copy.ts
//
// Shared user-visible copy for the content domain.
//
// Scope (inline-vs-shared policy): this module contains copy that is
// shared across MULTIPLE content-domain surfaces (the detail skeleton
// label consumed by `ArticleDetailPage` and the bespoke TA20.x
// routes). Route-specific Finnish strings (e.g. a bespoke route's CTA
// label, an insurance-number row label) stay co-located with the
// route — they don't belong here. The future i18n migration via
// `t(...)` calls will move every literal in lockstep, regardless of
// which file currently owns it; the inline-vs-shared split is purely
// about cohesion, not about who lives in `copy.ts`.
//
// Note on FR-018: the per-article demo-disclosure aside that this
// module previously owned was removed during the proto-parity sweep
// (see `docs/governance/proto-divergences.md` D-PD-003). The route-
// level demo posture (login disclaimer + DemoSessionProvider +
// demo-seed naming) carries the Demo/Fake Transparency Contract; the
// per-surface aside was redundant honesty that visually contradicted
// the prototype's rendering.
//
// I18N_HOOKUP_TA18: when an `apps/web/src/i18n/messages/{fi,en}.ts`
// `content.*` namespace lands, replace these constants with `t(...)`
// calls. Until then, copy is hardcoded Finnish (the demo's only
// shipped locale).

/** AT live-region label for `ArticleDetailPage`'s loading skeleton. */
export const DETAIL_SKELETON_LABEL_COPY: string = 'Ladataan artikkelia';
